<template>
    <div
        :class="['basket__menu', isOpen ? 'is-open' : '']"
        ref="basketMenu"
        @click="handleContentClick"
    >
        <div class="basket__wrap">
            <div class="basket__title">
                <span>Your cart</span>
                <a @click="closeForm()" class="cursor-pointer mobile-only tablet-only text-black">
                    <i class="icon-close"></i>
                </a>
            </div>
            <div class="basket__container" v-if="items.length > 0">
                <div class="basket__items products_items">
                    <template v-for="(item, i) in items" :key="`${item.product_id}-${item.variation_id}`">
                        <div class="product__item">
                            <div class="product__thumbnail" v-if="item.thumbnail?.thumbnail">
                                <img :src="item.thumbnail.thumbnail" loading="lazy" />
                            </div>
                            <div class="product__thumbnail" v-else>
                                <img :src="`${images_url}/empty/thumbnail_small.png`" loading="lazy" />
                            </div>
                            <div class="product__info">
                                <a :href="products[ item.product_id ].product_url || '/'" class="product__title">
                                    {{ products[ item.product_id ].product_title || '' }}
                                    <div class="product__variations" v-if="item.variation_id > 0">
                                        <template v-for="variation in products[ item.product_id ].variations">
                                            <template
                                                v-if="variation.id === item.variation_id && item.properties"
                                            >
                                            <span
                                                class="product__variation"
                                                v-for="prop in item.properties"
                                                :key="prop.id"
                                            >
                                                <span class="product__group">{{ prop.group_name }}:</span>
                                                <span class="product__property_name">{{ prop.property_name }}</span>
                                            </span>
                                            </template>
                                        </template>
                                    </div>
                                </a>
                                <button class="product__delete" @click="removeItem(i)" title="Delete Item">
                                    <i class="icon-trash"></i> Delete
                                </button>
                            </div>
                            <div class="product__prices">
                                <div class="product__sale_price">
                                    {{ NumberFormat.format(item.sale_price / 100) }}
                                </div>
                                <div class="product__price" v-if="!!item?.sale_grant">
                                    {{ NumberFormat.format(item.sale_grant / 100) }}
                                </div>
                                <div class="product__price" v-if="1 === 0 && item.sale_price < item.price">
                                    {{ NumberFormat.format(item.price / 100) }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="basket__action" v-if="items.length > 0">
                <div class="basket__subtotal">
                    <span class="basket__label">Estimated total:</span>
                    <span class="basket__computed d-flex align-center gap-sm">
                        <span class="d-inline-flex text-small bg-light-green fw-bold py-xs px-sm radius-md"
                             v-if="grant && items.length > 0"
                        >
                            <i class="icon-gift"></i> Grant applied
                        </span>
                        <span>{{ NumberFormat.format( total / 100) }}</span>
                    </span>
                </div>
                <button class="btn btn--primary btn--full" @click="toCheckout()">Go to checkout</button>
                <div class="caption text-center mt-sm">Fees & taxes are calculated at checkout</div>
            </div>
            <div class="basket__empty pt-lg pb-ml" v-else>
                Cart is empty
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { toRaw } from 'vue';

const BASKET_BTN = 'basketMenu'; // кнопка корзины
const CART_KEY   = 'cartItems';
const TOTAL_KEY  = 'cartTotal';

const KEY = 'cart'; // Ключ для localStorage
const TTL = 5 * 60 * 1000; // 5 минут для localStorage
// const TTL = 0; // 5 минут для localStorage

export default defineComponent({
    name: "Cart",
    data() {
        return {
            images_url: '/templates/BinaryFlow/assets/images',
            stats: window.stats || [],
            NumberFormat: {},
            isOpen: false,
            isLoading: false,
            basketMenu: false,
            items: [],
            items_original: [],
            products: {},
            inputTimeout: null,

            grant: window.grant || false, // есть ли грант
            ball: window.ball || 0, // сколько на балансе
        };
    },
    created() {
        this.NumberFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: this.stats.currency || 'USD'});
    },
    mounted() {
        this.basketMenu = document.getElementById( BASKET_BTN )
        if( this.basketMenu ) {
            this.basketMenu.addEventListener('click', async () => {
                await this.addListener()
            })
        }

        this.init()

        // слушаем событие добавления в корзину
        document.addEventListener('addToCart', this.handleAddToCart);
    },
    beforeUnmount() {
        this.removeClickListener();

        document.removeEventListener('addToCart', this.handleAddToCart);
        if( this.basketMenu )
            this.basketMenu.removeEventListener( 'click', this.addListener )
    },
    computed: {
        total() {
            return this.items.reduce((sum, item) => sum + item.sale_price, 0);
        },
        items_count() {
            return this.items.reduce((qty, item) => qty + item.quantity, 0);
        },
    },
    watch: {
        // Следим за изменениями массива items
        items_original: {
            handler() {
                if( this.basketMenu ) {
                    const isEmpty = this.items_original.length === 0;
                    this.basketMenu.classList.remove('lamp-on', 'lamp-off');
                    this.basketMenu.classList.add( ! isEmpty ? 'lamp-on' : 'lamp-off');
                }
            },
            // Важно: отслеживаем изменения содержимого массива
            deep: true
        }
    },
    methods: {
        /** Бокс */
        async addListener() {
            try {
                // Ждем, пока меню полностью откроется
                await this.openForm()
                document.addEventListener('click', this.handleClickOutside, { passive: false })
            } catch (error) {
                console.error('Error when try to open form:', error)
            }
        },
        openForm() {
            return new Promise((resolve) => {
                // открываем форму search
                this.isOpen = true;

                // добавить анимацию или другие асинхронные операции?
                setTimeout(() => {
                    resolve()
                }, 300)
            })
        },
        closeForm() {
            this.isOpen = false;
            this.removeClickListener()
        },
        // обработка клика внутри контента
        handleContentClick( event ) {
            this.handleClickOutside( event );
            event.stopPropagation() // Останавливаем распространение события
        },
        // Удаление слушателя клика
        removeClickListener() {
            document.removeEventListener( 'click', this.handleClickOutside )
        },
        // обработка клика вне компонента
        handleClickOutside(event) {
            const c1 = document.querySelector('.basket__menu')
            if(
                this.$refs.basketMenu &&
                this.isOpen &&
                ! c1.contains( event.target )
                && ! this.$refs.basketMenu.contains( event.target )
            ) {
                this.closeForm()
            }
        },
        // переход в корзину
        toCheckout() {
            window.location.href = window.location.origin + '/checkout';
        },

        /**
         * Запрос к серверу для добавления/обновления/удаления корзины на сервере
         *
         * @param item
         * @returns {Promise<void>}
         */
        async set( item ) {

            if( this.isLoading )
                return;

            this.isLoading = true

            try {
                const response = await this.$http.post('/cart/update', item);
                this.items_original = response.data.data.items
                this.products = response.data.data.products;
                this.prepareItems();
                this.saveCache(); // обновляем кэш
            } catch ( err ) {
                console.error('Error loading cart:', err);
            } finally {
                setTimeout(() => {
                    this.isLoading = false;
                }, 500)
            }
        },

        /**
         * Нужно ли обновить localStorage
         * @returns {boolean}
         */
        needClearStorage() {
            const path = window.location.pathname;
            const poo = path.split('/').filter(Boolean); // разбираем на части и убираем пусты
            if( poo[0] === 'success' && poo[1] ) {
                const order_id = poo[1];
                const cleared_id = localStorage.getItem('last_cleared_order');
                if( cleared_id !== order_id ) {
                    localStorage.setItem('last_cleared_order', order_id);
                    return true;
                }
            }

            return false;
        },

        /**
         * Инициализация страницы
         */
        async init() {

            if( this.isLoading )
                return;

            const needUpdate = this.needClearStorage();
            if( ! needUpdate ) {
                // Получить данные (если не устарели)
                const stored = localStorage.getItem( KEY );
                if( stored ) {
                    const data = JSON.parse(stored);
                    if( Date.now() - data.timestamp <= TTL ) {
                        this.items_original = data.items || []
                        this.products = data.products || [];
                        this.prepareItems();
                        this.eventUpdatedCart();
                        return;
                    }
                }
            }

            this.isLoading = true

            try {
                const response = await this.$http.post('/cart/get');

                // Критическая проверка структуры
                if( response.data?.data?.items && Array.isArray( response.data.data.items ) ) {
                    this.items_original = response.data.data.items;
                    this.products = response.data.data.products;
                } else {
                    console.warn('Items not found in response, resetting to empty array');
                    this.items_original = [];
                    this.items = [];
                    this.products = {};
                }

                this.prepareItems();
                this.saveCache(); // Обновляем кэш
            } catch ( err ) {
                console.error('Error loading cart:', err);
            } finally {
                setTimeout(() => {
                    this.isLoading = false;
                }, 500)
            }
        },

        prepareItems() {

            if( this.grant ) {
                let ioo = [];
                let amount_wallet = this.ball
                this.items_original.forEach(( i ) => {

                    let ii = structuredClone( toRaw( i ) );

                    ii.sale_grant = ii.sale_price;
                    if( amount_wallet > ii.sale_price ) {
                        amount_wallet -= ii.sale_price;
                        ii.sale_price = 0;
                    } else {
                        ii.sale_price = ii.sale_price - amount_wallet;
                        amount_wallet = 0;
                    }

                    ioo.push( ii )
                })

                this.items = ioo;
            } else {
                this.items = this.items_original;
            }
        },

        // обновляем данные при внешнем добавлении
        handleAddToCart( e ) {
            // отправляем на сервер данные
            this.set(e.detail);
        },

        delayedUpdate(index, value) {
            clearTimeout( this.inputTimeout );
            this.inputTimeout = setTimeout(() => {
                this.updateQuantity( index, value );
            }, 300);
        },

        // Удаляем позицию из корзины
        removeItem( index ) {
            this.updateQuantity( index, 0 )
            setTimeout(() => {
                this.items_original.splice( index, 1 );
            }, 300);
        },

        // Обновляем количество, удаляем позицию
        updateQuantity( index, qty ) {

            this.items_original[ index ].quantity = qty;
            let item = this.items_original[ index ];
            this.prepareItems();
            // Отправляем на сервер данные
            this.set( item )
        },

        // Сохранить кэш
        saveCache() {
            const data = {
                products: this.products,
                items: this.items_original,
                timestamp: Date.now()
            };
            localStorage.setItem( KEY, JSON.stringify(data) );
            this.eventUpdatedCart();
        },

        // Очистить кэш
        clearCache() {
            localStorage.removeItem( KEY );
        },
        // Отправляем событие - корзина обновлена
        eventUpdatedCart() {
            const e = new CustomEvent('updatedCart', {
                detail: {
                    storage: KEY
                },
                bubbles: true, // событие может распространяться по дереву DOM
                cancelable: true // можно отменить событие preventDefault()
            })
            document.dispatchEvent( e );
        }
    }
})
</script>

<style scoped>

</style>